// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_a_link_to_reset_your_password_has_been_sent: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `A link to reset your password has been sent to the email address you provided.`,
    es: `Un enlace para restablecer contraseňa fue enviado a la dirección de correo electrónico que fue proporcionada.`,
  };
  return phrases[locale] || phrases.en || 'a_link_to_reset_your_password_has_been_sent';
};
